<template>
  <div class="my-5 pa-5 border">
    <simple-table
        :table-title="$ucfirst($t('dss.algorithmInputs'))"
        :headers="['Property', 'Variable', 'Value']"
        :table-modifier-classes="['dss']"
        :rows="rows"
    />
  </div>
</template>

<script>
import dssSubjectMixin from 'dashboard/mixins/dss-subject.mixin';
import {UCUMUnit} from "../../../../helper/UCUMUnit";
import SimpleTable from "../../components/Parts/SimpleTable.vue";

/**
 * Component DSSAlgorithmInputs.vue
 *
 * @module DSSAlgorithmInputs
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/views/DSS/DSSAlgorithmInputs.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
export default {
  name: "DSSAlgorithmInputs",
  mixins: [dssSubjectMixin],
  created() {
    this.$app.eventBus.$on('DSSHeader.saveAndExit', this.saveAndExit)
  },
  beforeDestroy(){
    this.$app.eventBus.$off('DSSHeader.saveAndExit', this.saveAndExit)
  },
  methods: {
    saveAndExit: function(){
      this.$router.push({name: 'DSSMedicationPrescription'})
    }
  },
  components: {
    SimpleTable
  },
  computed: {
    rows() {
      const rows = [];

      for (let key in this.fields) {
        const field = this.fields[key];
        rows.push([
          field.label,
          field.edcVariable,
          this.dssInputHumanFriendly(key, this.dssInfo[key]) || '-'
        ])
      }

      return rows;
    }
  },
  data: function () {
    return {
      fields: {
        age: {label: 'Age', edcVariable: 'AGE'},
        gender: {label: 'Gender', edcVariable: 'SEX'},
        infarctionType: {label: 'If patient had an infarction, which type', edcVariable: 'CAIHD'},
        hasHistoryOfAtrialFibrillation: {label: 'Has history of atrial fibrillation', edcVariable: 'CAAF'},
        hadPCI: {label: 'Had PCI', edcVariable: 'CATREAT'},
        lastPCIDate: {label: 'Last PCI date', edcVariable: 'DCAPI'},
        hasHistoryOfMI: {label: 'Has history of MI', edcVariable: 'CAMI'},
        suffersFromSystolicHeartFailureOrLVDysfunction: {label: 'Suffers from systolic heart failure or LV dysfunction', edcVariable: 'CAHF/CAHFC'},
        CHA2DS2VAScScore: {label: 'CHA2DS2-VASc score', edcVariable: 'CACVS'},
        hasDiabetesType2: {label: 'Patient has diabetes type 2', edcVariable: 'MHPRES'},
        meanSystolicBloodPressure: {label: 'Mean systolic blood pressure', edcVariable: 'BPS'},
        meanDiastolicBloodPressure: {label: 'Mean diastolic blood pressure', edcVariable: 'BPD'},
        EGFR: {label: 'eGFR', edcVariable: 'CKDCY/CKD'},
        currentLDLMgDL: {label: 'LDL ' + UCUMUnit.MILLIGRAM_PER_DECILITER.unit, edcVariable: 'LDLBC'},
      }
    };
  },
};
</script>
